import { Injectable, signal } from '@angular/core';
import { emulateUser } from '../models/model';
import { Router } from '@angular/router';
import config from '../../../assets/config.json';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class EmulationService {
  private cookieName = btoa('emulatedUser');
  emulatedUser = signal<emulateUser | null>(this.loadEmulatedUser());
  refreshHeader = new Subject<any>();
  constructor(private _router: Router) {}

  startEmulation(userDetails: emulateUser) {
    this.emulatedUser.set(userDetails);
    this.setCookie(this.cookieName, btoa(JSON.stringify(userDetails)));
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate(['internal-tools/emulate-user']); // Force refresh
    });
  }

  stopEmulation() {
    this.emulatedUser.set(null);
    this.deleteCookie(this.cookieName);
    this.refreshHeader.next(null); // Notify subscribers to refresh header
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate(['internal-tools/emulate-user']); // Force refresh
    });
  }

  private setCookie(name: string, value: string) {
    const expires = new Date(Date.now() + Number(config.idleAppTimeOut)).toUTCString();
    document.cookie = `${name}=${value}; path=/; Secure; SameSite=Strict; expires=${expires}`;
    //  No expiration → Remains until manually deleted
  }

  private loadEmulatedUser(): emulateUser | null {
    const match = document.cookie.match(new RegExp('(^| )' + this.cookieName + '=([^;]+)'));
    return match ? JSON.parse(atob(match[2])) : null;
  }

  private deleteCookie(name: string) {
    document.cookie = `${name}=; path=/; Secure; SameSite=Strict; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
  }
  stopEmulationonLogout() {
    this.deleteCookie(this.cookieName);
  }
}
